import { create } from 'zustand';

interface Error {
  id?: string;
  message: string;
  errorRemovalTimeout?: number | null;
}

interface CartErrors {
  // Toggle
  isCartOpen: boolean;
  toggleCart: (isCartOpen: boolean) => void;

  // Errors
  errors: Error[];
  addError: (error: Error) => void;
  removeError: (errorId: string) => void;
  removeErrors: () => void;
}

export const useCartUI = create<CartErrors>((set, get) => ({
  // Toggle
  isCartOpen: false,
  toggleCart: (isCartVisible) => set(() => ({ isCartOpen: isCartVisible })),

  // Errors
  errors: [],
  removeError: (errorId) => {
    set((prevState) => ({
      errors: prevState.errors.filter((error) => error.id !== errorId),
    }));
  },
  removeErrors: () => {
    set(() => ({
      errors: [],
    }));
  },
  addError: (error) => {
    set((prevState) => ({
      errors: [...prevState.errors, error],
    }));

    if (error.errorRemovalTimeout) {
      setTimeout(() => {
        if (error.id) {
          get().removeError(error.id);
        }
      }, error.errorRemovalTimeout);
    }
  },
}));
